"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AppBar_1 = __importDefault(require("@material-ui/core/AppBar"));

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importDefault(require("react"));

var constants_1 = require("../../../constants");

var utils_1 = require("../../../utils");

var useStyles_1 = __importDefault(require("./useStyles"));
/**
 * The Base `Moment` that all other `Moment`s derive from.
 */


var MomentBase = function MomentBase(props) {
  var bodyClassName = props.bodyClassName,
      children = props.children,
      index = props.index,
      layout = props.layout,
      subtitle = props.subtitle,
      title = props.title,
      type = props.type;
  var classes = (0, useStyles_1.default)(props);
  var containerClasses = (0, utils_1.classList)(classes.container, 'story-moment', "story-moment-layout-" + layout, "story-moment-" + type);
  var bodyClasses = (0, utils_1.classList)('story-moment__content__body ', classes.content); // NOTE: The second toolbar is to prepend enough gutter space

  var toolBar = react_1.default.createElement(Toolbar_1.default, {
    className: classes.gutter
  }, react_1.default.createElement(Typography_1.default, {
    className: classes.headerText,
    variant: "h4"
  }, title), react_1.default.createElement(Typography_1.default, {
    className: classes.headerText,
    variant: "subtitle1"
  }, subtitle));
  return react_1.default.createElement(Grid_1.default, {
    container: true,
    className: containerClasses,
    id: "story-moment" + index,
    justifyContent: "center",
    key: "story-moment" + index
  }, react_1.default.createElement(AppBar_1.default, {
    className: classes.appBar
  }, toolBar), react_1.default.createElement(Grid_1.default, {
    className: classes.body,
    container: true
  }, react_1.default.createElement("span", {
    className: classes.bufferToolbar
  }, toolBar), react_1.default.createElement("div", {
    className: bodyClasses
  }, react_1.default.createElement("div", {
    className: bodyClassName + " " + classes.bodyInner
  }, children))));
};

MomentBase.propTypes = {
  /** Determines the body className. */
  bodyClassName: prop_types_1.default.string,

  /** Determines the background and text color of the `Moment` header. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),

  /** Used to serialize the order of the `Moment`s in a `Story` */
  index: prop_types_1.default.number,

  /** Determines the structural styling of the `Moment`. */
  layout: prop_types_1.default.string,

  /** Paragraph text underneath the title in `Moment` header */
  subtitle: prop_types_1.default.string,

  /** Main heading element of the `Moment` */
  title: prop_types_1.default.node,

  /** The type of `Moment` */
  type: prop_types_1.default.string
};
MomentBase.defaultProps = __assign(__assign({}, constants_1.MOMENT_BASE_DEFAULT_PROPS), {
  layout: constants_1.MomentLayout.Base,
  type: constants_1.MomentType.Base
});
exports.default = MomentBase;